import React from "react";
import Shell from "../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DashboardPresenter from "./DashboardPresenter";
import DTODashboard from "./DTODashboard";
import { useTranslation } from "react-i18next";
import { commonServices } from "../../api/services/commonServices";
import {
  setsignedprofilepic,
} from "../../infra/aggregates/profilePicSlice";
import { useAppDispatch, useAppSelector } from "../../infra/hooks";

function DashboardController() {
  const { t, i18n } = useTranslation();
  const selector = useAppSelector((state) => state);
  const dispatch = useAppDispatch();
  const setEmpProPic = (data: any) => {
    if (data) {
      const user_id: any = selector.authSlice.user_id;
      const companyID: any = selector.authSlice.company_id;
      const Payload = {
        filepath: data,
        fullpath: true,
      };
      commonServices
        .getFilePath(companyID, user_id, Payload)
        .then((res: any) => {
          //dispatch(setUserProfilePic(res));
          dispatch(setsignedprofilepic(res));
        })
        .catch((err) => {
          console.log("getFilePath---DashboardController----err-------", err);
        });
    }
  };
  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "6.3em" : "",
        }}
      >
        <DTODashboard getempProPic={setEmpProPic} />
        <DashboardPresenter i18n={i18n} trans={t} />
      </Grid>
    </Shell>
  );
}
export default DashboardController;
